(function () {
  var root = document.getElementById('avn-lv');
  if (!root) return;
  var panelEl = document.getElementById('avn-lv-panel');
  var resultsEl = document.getElementById('avn-lv-results');
  var bodyEl = document.getElementById('avn-lv-body');
  var COLLECTION = root.getAttribute('data-collection') || '';
  var SHOP_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var CACHE_KEY = 'avn-lv-v1-' + COLLECTION;
  var CACHE_MS = 10 * 60 * 1000;

  var OCC = [['date','Õhtune kohting'],['daily','Igapäev ja kontor'],['party','Pidu ja klubi'],['summer','Suvi ja rand'],['cozy','Hubane sügis ja talv'],['special','Eriline sündmus']];
  var GEN = [['any','Pole vahet'],['f','Naisele'],['m','Mehele'],['u','Unisex']];
  var GEN_LABEL = {f:'Naistele',m:'Meestele',u:'Unisex'};
  var FAM = [['Värske','tsitrus, puhas, mereline'],['Lilleline','roos, jasmiin, pojeng'],['Puuviljane','mahlane, magus puuvili'],['Magus','vanill, karamell, gurmee'],['Puidune','seeder, sandlipuu, vetiver'],['Aromaatne','lavendel, salvei, ürdid'],['Vürtsikas','pipar, kaneel, ingver'],['Idamaine','merevaik, vaigud, oud']];
  var NOTE_GROUPS = [['Vanill',/vanil/],['Tsitrused',/sidrun|bergamo|greip|mandariin|apelsin|laim|yuzu|tsitrus/],['Roos',/roos(?!a)/],['Jasmiin',/jasmiin/],['Merevaik',/merevaik|ambr/],['Muskus',/muskus|mosk/],['Sandlipuu',/sandlipuu/],['Patšuli',/patšuli/],['Kaneel',/kaneel/],['Tubakas',/tubak/],['Kohv',/kohv/],['Ingver',/ingver/],['Lavendel',/lavend|lavandiin/],['Õun',/õun/],['Mandel',/mandel/]];
  var FMT = [['all','Kõik'],['full','Täispudel'],['sample','Proovipudel']];
  var ADJ = {date:['party','cozy','special'],party:['date','special'],cozy:['date'],summer:['daily'],daily:['summer'],special:['date','party']};
  var INT_TXT = ['','Nahalähedane','Õrn','Mõõdukas','Selgelt tuntav','Jätab jälje'];
  var FAM_NAMES = FAM.map(function (f) { return f[0]; });
  var FAM_W = {'Värske':-24,'Aromaatne':-6,'Magus':16,'Vürtsikas':9,'Idamaine':14,'Puidune':4,'Lilleline':-2,'Puuviljane':-5};
  var FAM_HUE = {'Värske':192,'Lilleline':340,'Puuviljane':22,'Magus':36,'Puidune':30,'Aromaatne':120,'Vürtsikas':12,'Idamaine':24};
  var NICHE = ['Xerjoff','Kilian Paris','Louis Vuitton','Chanel','Guerlain','Dior','Sospiro','Amouage','Creed','Tom Ford','Initio','Parfums de Marly','Byredo','Le Labo','Nishane','Montale','Mancera'];
  var DEFAULTS = {occ:'date',gen:'any',int:4,warm:65,fam:['Magus','Vürtsikas'],notes:['Vanill'],fmt:'all'};
  var st = JSON.parse(JSON.stringify(DEFAULTS));
  var catalog = null, loadState = 'idle', lastTrigger = null, isOpen = false, pushed = false, openedByPath = false;

  var cssEsc = function (s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/(["\\])/g, '\\$1'); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
  var plain = function (s) { return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); };
  var occLabel = function (k) { for (var i = 0; i < OCC.length; i++) if (OCC[i][0] === k) return OCC[i][1]; return k; };
  var money = function (p) {
    if (p == null) return '';
    try { return new Intl.NumberFormat('et-EE', {style:'currency',currency:CURRENCY,minimumFractionDigits:p % 1 ? 2 : 0,maximumFractionDigits:2}).format(p); }
    catch (e) { return p + ' €'; }
  };

  /* ---------- Andmed poest ---------- */
  var STOP = '(?=(Tipunoo(?:did|t)|Südamenoo(?:did|t)|Põhjanoo(?:did|t)|Miks valida|Kellele sobib|Tooteinfo|Mis on lõhnanäidis|Peamised noodid|Tootja|Pakend|Originaalpudel|Täissuuruses parfüüm|Lõhnanäidis|$))';
  function grab(d, label) {
    var m = new RegExp(label + '\\s*:\\s*([\\s\\S]*?)' + STOP).exec(d);
    return m ? m[1].replace(/^[\s.]+|[\s.]+$/g, '') : '';
  }
  function splitNotes(s) {
    s = s.replace(/\([^)]*\)/g, '');
    var out = [];
    s.split(/,|\sja\s|\.\s/).forEach(function (part) {
      var p = part.replace(/^[\s.]+|[\s.]+$/g, '').toLowerCase();
      if (p && p.length < 34 && out.indexOf(p) < 0) out.push(p);
    });
    return out.slice(0, 7);
  }
  function htmlToText(html) {
    var t = String(html || '').replace(/<[^>]+>/g, ' ');
    var ta = document.createElement('textarea');
    ta.innerHTML = t;
    return ta.value.replace(/\s+/g, ' ').trim();
  }
  function niceName(base, vendor) {
    var n = base, v = vendor || '';
    if (plain(n).indexOf(plain(v)) === 0 && v) n = n.slice(v.length).trim();
    else if (v) {
      var w = v.split(' ');
      if (plain(n).indexOf(plain(w[0])) === 0) n = n.split(' ').slice(w.length).join(' ') || n;
    }
    n = n.replace(/\s+(Eau de Toilette|Eau de Parfum|Extrait de Parfum)$/, '');
    return n.trim() || base;
  }
  function tagList(p) {
    var t = p.tags || [];
    if (typeof t === 'string') t = t.split(',');
    return t.map(function (x) { return String(x).trim(); });
  }
  function tagNum(tags, prefix) {
    for (var i = 0; i < tags.length; i++) if (tags[i].indexOf(prefix) === 0) { var n = parseInt(tags[i].slice(prefix.length), 10); if (!isNaN(n)) return n; }
    return null;
  }

  function parseProducts(products) {
    var map = {};
    products.forEach(function (p) {
      var tags = tagList(p);
      if (tags.indexOf('lv-peida') > -1) return;
      var ptype = p.product_type || '';
      var text = htmlToText(p.body_html);
      var isSample = /lõhnanäidis/i.test(ptype);
      var isPerfume = /parfüüm|lõhnanäidis/i.test(ptype) || /Lõhnanoodid/.test(text);
      if (!isPerfume) return;
      var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
      if (!variants.length) return;
      var price = Math.min.apply(null, variants.map(function (v) { var x = parseFloat(v.price); return x > 0 ? x : Infinity; }));
      if (!isFinite(price)) price = null;
      var base = String(p.title).replace(/\s+[–-]\s+lõhnanäidis$/i, '').trim();
      var key = plain(base);
      var c = map[key];
      if (!c) c = map[key] = {base:base,b:p.vendor || '',g:'u',f:[],y:'',t:[],h:[],bs:[],m:[],a:false,fu:null,sa:null,img:'',tags:[]};
      var top = splitNotes(grab(text, 'Tipunoo(?:did|t)')), heart = splitNotes(grab(text, 'Südamenoo(?:did|t)')), bot = splitNotes(grab(text, 'Põhjanoo(?:did|t)'));
      var main = splitNotes(grab(text, '(?:Peamised noodid(?: ja akordid)?|Lõhna põhielemendid|Tootja esile toodud noodid)'));
      var fm = /Lõhnaperekond\s+(.{0,140})/.exec(text), fam = [];
      if (fm) {
        var seg = fm[1].split(/Suurus/)[0];
        fam = FAM_NAMES.filter(function (n) { return seg.indexOf(n) > -1; }).sort(function (a, b) { return seg.indexOf(a) - seg.indexOf(b); });
      }
      var ty = '';
      var tm = /Lõhnatüüp\s+(Eau de Toilette|Eau de Parfum|Parfum)/.exec(text);
      if (tm) ty = {'Eau de Toilette':'EDT','Eau de Parfum':'EDP','Parfum':'Parfum'}[tm[1]];
      else if (/Eau de Toilette/i.test(base)) ty = 'EDT';
      else if (/Extrait|\bParfum$/.test(base)) ty = 'Parfum';
      else if (/Eau de Parfum/i.test(base)) ty = 'EDP';
      var g = tags.indexOf('Naistele') > -1 ? 'f' : tags.indexOf('Meestele') > -1 ? 'm' : 'u';
      var img = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '';
      c.a = c.a || tags.indexOf('araabia-parfuum') > -1;
      c.g = g; c.tags = c.tags.concat(tags);
      if (fam.length && !c.f.length) c.f = fam;
      if (top.length && !c.t.length) c.t = top;
      if (heart.length && !c.h.length) c.h = heart;
      if (bot.length && !c.bs.length) c.bs = bot;
      if (main.length && !c.m.length) c.m = main;
      if (ty && !c.y) c.y = ty;
      if (img && (!c.img || !isSample)) c.img = img;
      var entry = {h:p.handle,p:price};
      if (isSample) c.sa = entry; else c.fu = entry;
    });
    return Object.keys(map).map(function (k) { return finish(map[k]); }).filter(Boolean);
  }

  function finish(c) {
    if (!c.fu && !c.sa) return null;
    var p = {id:plain(c.base).replace(/[^a-z0-9]+/g, '-'), n:niceName(c.base, c.b), b:c.b, g:c.g, f:c.f, t:c.t, h:c.h, bs:c.bs, m:c.m, a:c.a, fu:c.fu, sa:c.sa, img:c.img};
    p.y = c.y || 'EDP';
    var w = 50;
    p.f.forEach(function (x) { w += FAM_W[x] || 0; });
    w = Math.max(6, Math.min(94, w));
    var i = {EDT:2,EDP:3,Parfum:4}[p.y] || 3;
    if (p.a) i++;
    if (/Intens|Extrait|Extreme|Black|Night|Nuit|Le Parfum|Flame|Bourbon|Liquid|Starlight|Collector|Khamrah|Ombre|Fireplace|Supremacy|Scandal|Naxos|Angels/.test(c.base)) i++;
    if (p.f.indexOf('Värske') > -1 && w <= 35 && p.y === 'EDT') i = Math.min(i, 2);
    var ti = tagNum(c.tags, 'lv-i-'), tw = tagNum(c.tags, 'lv-w-');
    if (ti != null) i = ti;
    if (tw != null) w = tw;
    p.i = Math.max(1, Math.min(5, i));
    p.w = Math.max(0, Math.min(100, w));
    var price = (p.fu && p.fu.p) || 0, fam = p.f, o = [];
    var has = function (x) { return fam.indexOf(x) > -1; };
    var niche = NICHE.indexOf(p.b) > -1;
    if (p.w <= 38) o.push('summer');
    if (p.i <= 3 && p.w <= 68) o.push('daily');
    if (p.w >= 45 && p.i >= 3 && (has('Magus') || has('Idamaine') || has('Lilleline') || has('Vürtsikas') || has('Puidune'))) o.push('date');
    if (p.i >= 4 || (p.w >= 60 && p.i >= 3 && has('Magus'))) o.push('party');
    if (p.w >= 62) o.push('cozy');
    if (p.i >= 4 && (price >= 60 || p.w >= 60 || niche)) o.push('special');
    if (!o.length) o.push('daily');
    p.o = o;
    p.text = [].concat(p.t, p.h, p.bs, p.m).join(' ').toLowerCase();
    p.noteHits = NOTE_GROUPS.filter(function (g) { return g[1].test(p.text); }).map(function (g) { return g[0]; });
    var hs = 0; for (var k = 0; k < p.id.length; k++) hs = (hs * 31 + p.id.charCodeAt(k)) % 997;
    var base = FAM_HUE[p.f[0]] != null ? FAM_HUE[p.f[0]] : 30;
    p.color = 'hsl(' + ((base + (hs % 17) - 8 + 360) % 360) + ',' + (58 + (hs % 14)) + '%,' + Math.round(66 - p.w * 0.26) + '%)';
    return p;
  }

  async function fetchAll() {
    var url = SHOP_ROOT + (COLLECTION ? 'collections/' + encodeURIComponent(COLLECTION) + '/' : '') + 'products.json';
    var all = [];
    for (var page = 1; page <= 10; page++) {
      var r = await fetch(url + '?limit=250&page=' + page, {headers:{Accept:'application/json'}});
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var j = await r.json();
      var ps = j.products || [];
      all = all.concat(ps);
      if (ps.length < 250) break;
    }
    return all;
  }

  async function loadCatalog() {
    if (catalog || loadState === 'loading') return;
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) { var o = JSON.parse(raw); if (Date.now() - o.ts < CACHE_MS) { catalog = o.data; loadState = 'ready'; render(); return; } }
    } catch (e) {}
    loadState = 'loading'; render();
    try {
      catalog = parseProducts(await fetchAll());
      loadState = 'ready';
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ts:Date.now(),data:catalog})); } catch (e) {}
    } catch (e) { loadState = 'error'; }
    render();
  }

  /* ---------- Sobivus ---------- */
  function score(p) {
    var s = 0;
    if (p.o.indexOf(st.occ) > -1) s += 30;
    else if ((ADJ[st.occ] || []).some(function (k) { return p.o.indexOf(k) > -1; })) s += 12;
    s += 15 * (1 - Math.abs(p.i - st.int) / 4);
    s += 15 * (1 - Math.abs(p.w - st.warm) / 100);
    var famHits = st.fam.filter(function (f) { return p.f.indexOf(f) > -1; });
    s += st.fam.length ? 20 * famHits.length / st.fam.length : 10;
    var noteHits = st.notes.filter(function (n) { return p.noteHits.indexOf(n) > -1; });
    s += st.notes.length ? 15 * noteHits.length / st.notes.length : 7;
    if (st.gen === 'any' || p.g === st.gen) s += 5; else if (p.g === 'u') s += 3; else s -= 30;
    return {p:p, pct:Math.max(5, Math.min(98, Math.round(100 - (100 - s) * 1.6))), famHits:famHits, noteHits:noteHits};
  }
  function ranked() {
    return catalog
      .filter(function (p) { return st.fmt === 'all' || (st.fmt === 'full' ? p.fu : p.sa); })
      .map(score)
      .sort(function (a, b) { return b.pct - a.pct || a.p.n.localeCompare(b.p.n, 'et'); });
  }

  /* ---------- Kuvamine ---------- */
  function link(handle) { return SHOP_ROOT + 'products/' + encodeURIComponent(handle); }
  function imgUrl(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function bottle(p) {
    return '<svg class="avn-bottle" viewBox="0 0 80 120" aria-hidden="true"><rect x="30" y="10" width="20" height="14" fill="#212326"/><rect x="35" y="24" width="10" height="20" fill="#d2d5d9"/>' +
      '<clipPath id="avn-c-' + esc(p.id) + '"><rect x="14" y="42" width="52" height="68" rx="6"/></clipPath><g clip-path="url(#avn-c-' + esc(p.id) + ')"><rect x="14" y="42" width="52" height="68" fill="#fff"/><rect x="14" y="60" width="52" height="60" fill="' + p.color + '"/></g>' +
      '<rect x="14" y="42" width="52" height="68" rx="6" fill="none" stroke="#212326" stroke-width="1.5"/></svg>';
  }
  function media(p, href, badge, w) {
    return '<a class="avn-media" href="' + href + '" tabindex="-1" aria-hidden="true">' +
      (p.img ? '<img src="' + esc(imgUrl(p.img, w)) + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : bottle(p)) + (badge ? '<span class="avn-badge">' + badge + '</span>' : '') + '</a>';
  }
  function noteList(a) { return a.map(function (n) { return esc(cap(n)); }).join(', '); }
  function reasons(r) {
    var p = r.p, out = [];
    if (p.o.indexOf(st.occ) > -1) out.push('Sobib olukorda: ' + occLabel(st.occ).toLowerCase());
    if (r.famHits.length) out.push('Lõhnaperekond: ' + r.famHits.join(', ').toLowerCase());
    if (r.noteHits.length) out.push('Sinu lemmiknoodid: ' + r.noteHits.join(', ').toLowerCase());
    var d = p.i - st.int;
    if (d === 0) out.push('Intensiivsus on täpselt see, mille valisid');
    else if (Math.abs(d) === 1) out.push(d > 0 ? 'Natuke tugevam, kui valisid' : 'Natuke õrnem, kui valisid');
    return out.slice(0, 4);
  }
  function pyramid(p) {
    var rows = [];
    if (p.t.length) rows.push(['Pealmised', p.t]);
    if (p.h.length) rows.push(['Süda', p.h]);
    if (p.bs.length) rows.push(['Alus', p.bs]);
    if (!rows.length && p.m.length) rows.push(['Peamised', p.m]);
    return rows.map(function (r) { return '<div class="avn-tier"><dt>' + r[0] + '</dt><dd>' + noteList(r[1]) + '</dd></div>'; }).join('');
  }
  function card(r, i) {
    var p = r.p, main = p.fu || p.sa, btns = [];
    if (p.fu) btns.push('<a class="avn-btn main" href="' + link(p.fu.h) + '">Täispudel' + (p.fu.p ? ' alates ' + money(p.fu.p) : '') + '</a>');
    if (p.sa) btns.push('<a class="avn-btn' + (p.fu ? '' : ' main') + '" href="' + link(p.sa.h) + '">Proovipudel' + (p.sa.p ? ' alates ' + money(p.sa.p) : '') + '</a>');
    var dots = [1,2,3,4,5].map(function (n) { return '<i class="' + (n <= p.i ? 'on' : '') + '"></i>'; }).join('');
    var fams = p.f.map(function (f) { return '<span class="avn-tag' + (st.fam.indexOf(f) > -1 ? ' on' : '') + '">' + esc(f) + '</span>'; }).join('');
    return '<article class="avn-card">' + media(p, link(main.h), (i + 1) + '. valik', 520) +
      '<div class="avn-cb"><div><div class="avn-brand">' + esc(p.b) + '</div><h3 class="avn-name"><a href="' + link(main.h) + '">' + esc(p.n) + '</a></h3></div>' +
      '<div class="avn-tags"><span class="avn-tag">' + esc(p.y) + '</span><span class="avn-tag">' + GEN_LABEL[p.g] + '</span>' + fams + '</div>' +
      '<div class="avn-match"><div class="avn-bar"><i style="width:' + r.pct + '%"></i></div><span class="avn-pct">' + r.pct + '% sobib</span></div>' +
      '<ul class="avn-why">' + reasons(r).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' +
      '<dl class="avn-py">' + pyramid(p) + '</dl>' +
      '<div class="avn-int">Intensiivsus <span class="avn-dots" title="' + p.i + ' / 5">' + dots + '</span></div>' +
      '<div class="avn-buy">' + btns.join('') + '</div></div></article>';
  }
  function mini(r) {
    var p = r.p, main = p.fu || p.sa;
    return '<a class="avn-mini" href="' + link(main.h) + '">' + media(p, link(main.h), r.pct + '%', 300) +
      '<b>' + esc(p.b + ' ' + p.n) + '</b><small>' + esc(p.f.slice(0, 3).join(', ')) + ' · ' + esc(p.y) + '</small></a>';
  }

  function chips(items, isOn, attr) {
    return items.map(function (it) {
      return '<button type="button" class="avn-chip" ' + attr + '="' + esc(it[0]) + '" aria-pressed="' + isOn(it[0]) + '"' + (it[2] ? ' title="' + esc(it[2]) + '"' : '') + '>' + esc(it[1] || it[0]) + '</button>';
    }).join('');
  }
  function warmTxt(w) { return w < 25 ? 'Väga värske' : w < 50 ? 'Pigem värske' : w < 75 ? 'Pigem soe' : 'Soe ja sügav'; }

  function buildPanel() {
    panelEl.innerHTML =
      '<fieldset class="avn-fs"><legend>Millal kannad?</legend><div class="avn-chips" id="avn-occ"></div></fieldset>' +
      '<fieldset class="avn-fs"><legend>Kellele?</legend><div class="avn-chips" id="avn-gen"></div></fieldset>' +
      '<fieldset class="avn-fs"><div class="avn-rh"><legend>Intensiivsus</legend><span class="avn-rv" id="avn-intv"></span></div>' +
        '<input type="range" id="avn-int" min="1" max="5" step="1" value="4" aria-label="Intensiivsus"><div class="avn-re"><span>Nahalähedane</span><span>Jätab jälje</span></div></fieldset>' +
      '<fieldset class="avn-fs"><div class="avn-rh"><legend>Iseloom</legend><span class="avn-rv" id="avn-warmv"></span></div>' +
        '<input type="range" id="avn-warm" min="0" max="100" step="5" value="65" aria-label="Värske kuni soe"><div class="avn-re"><span>Värske</span><span>Soe ja sügav</span></div></fieldset>' +
      '<fieldset class="avn-fs"><legend>Lõhnaperekond</legend><div class="avn-chips" id="avn-fam"></div></fieldset>' +
      '<fieldset class="avn-fs"><legend>Noodid, mida armastad</legend><div class="avn-chips" id="avn-notes"></div></fieldset>' +
      '<fieldset class="avn-fs"><legend>Pudel</legend><div class="avn-chips" id="avn-fmt"></div></fieldset>' +
      '<button type="button" class="avn-reset" data-avn-reset>Lähtesta valikud</button>' +
      '<div class="avn-jump"><button type="button" class="avn-btn main" data-avn-jump>Vaata soovitusi</button></div>';
  }
  function updatePanel() {
    if (!document.getElementById('avn-occ')) buildPanel();
    var set = function (id, html) { document.getElementById(id).innerHTML = html; };
    set('avn-occ', chips(OCC, function (k) { return st.occ === k; }, 'data-occ'));
    set('avn-gen', chips(GEN, function (k) { return st.gen === k; }, 'data-gen'));
    set('avn-fam', chips(FAM.map(function (f) { return [f[0], f[0], f[1]]; }), function (k) { return st.fam.indexOf(k) > -1; }, 'data-fam'));
    set('avn-notes', chips(NOTE_GROUPS.map(function (g) { return [g[0]]; }), function (k) { return st.notes.indexOf(k) > -1; }, 'data-note'));
    set('avn-fmt', chips(FMT, function (k) { return st.fmt === k; }, 'data-fmt'));
    document.getElementById('avn-intv').textContent = st.int + ' / 5 · ' + INT_TXT[st.int];
    document.getElementById('avn-warmv').textContent = warmTxt(st.warm);
    var ri = document.getElementById('avn-int'), rw = document.getElementById('avn-warm');
    if (+ri.value !== st.int) ri.value = st.int;
    if (+rw.value !== st.warm) rw.value = st.warm;
  }

  function render() {
    if (!isOpen) return;
    var focusSel = null, ae = document.activeElement;
    if (ae && ae.dataset) { var k = Object.keys(ae.dataset).filter(function (x) { return /^(occ|gen|fam|note|fmt)$/.test(x); })[0]; if (k) focusSel = '[data-' + k + '="' + cssEsc(ae.dataset[k]) + '"]'; }
    updatePanel();
    if (focusSel) { var again = panelEl.querySelector(focusSel); if (again) again.focus(); }
    if (loadState === 'loading' || loadState === 'idle') { resultsEl.innerHTML = '<div class="avn-msg">Laen lõhnu poest…</div>'; return; }
    if (loadState === 'error' || !catalog) { resultsEl.innerHTML = '<div class="avn-msg">Lõhnade laadimine ei õnnestunud. Vaata kogu valikut <a href="' + SHOP_ROOT + 'collections/all">poe lehelt</a>.</div>'; return; }
    var list = ranked();
    var sum = '<p class="avn-sum"><b>' + esc(occLabel(st.occ)) + '</b> · ' + esc(INT_TXT[st.int].toLowerCase()) + ' · ' + esc(warmTxt(st.warm).toLowerCase()) +
      (st.fam.length ? ' · ' + esc(st.fam.join(', ').toLowerCase()) : '') + (st.notes.length ? ' · ' + esc(st.notes.join(', ').toLowerCase()) : '') +
      '. Vaatasin läbi ' + list.length + ' lõhna, mis on praegu poes saadaval.</p>';
    if (!list.length) { resultsEl.innerHTML = sum + '<div class="avn-msg">Selle valikuga lõhnu ei leitud. Proovi pudeli valikuks "Kõik".</div>'; return; }
    resultsEl.innerHTML = sum + '<div class="avn-top">' + list.slice(0, 3).map(card).join('') + '</div>' +
      (list.length > 3 ? '<div><p class="avn-more-t">Veel sobivad</p><div class="avn-grid">' + list.slice(3, 11).map(mini).join('') + '</div></div>' : '');
  }

  /* ---------- Avamine ja sulgemine ---------- */
  function openPicker(fromPath) {
    if (isOpen) return;
    isOpen = true; openedByPath = !!fromPath;
    lastTrigger = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (!fromPath && location.hash !== '#lohnavalija') { try { history.pushState({avn:1}, '', '#lohnavalija'); pushed = true; } catch (e) {} }
    render();
    var close = root.querySelector('.avn-lv__close'); if (close) close.focus();
    if (loadState === 'idle' || loadState === 'error') { loadState = 'idle'; loadCatalog(); } else if (catalog) render();
  }
  function hidePicker() {
    if (!isOpen) return;
    isOpen = false; root.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger && lastTrigger.focus && document.contains(lastTrigger)) { try { lastTrigger.focus(); } catch (e) {} }
    if (openedByPath) location.href = SHOP_ROOT;
  }
  function closePicker() {
    if (!isOpen) return;
    if (pushed) { pushed = false; history.back(); }
    else { if (location.hash === '#lohnavalija') { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} } hidePicker(); }
  }
  window.addEventListener('popstate', function () { if (isOpen && location.hash !== '#lohnavalija') { pushed = false; hidePicker(); } else if (!isOpen && location.hash === '#lohnavalija') openPicker(false); });

  function isTrigger(a) {
    if (!a || !a.getAttribute) return false;
    if (a.hasAttribute('data-lohnavalija')) return true;
    var href = a.getAttribute('href') || '';
    return /(^|\/)#lohnavalija$/.test(href) || href === '#lohnavalija' || /\/pages\/lohnavalija\/?(\?.*)?$/.test(href);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a,button,[data-lohnavalija]');
    if (a && root.contains(a)) return;
    if (a && isTrigger(a)) { e.preventDefault(); e.stopImmediatePropagation(); openPicker(false); }
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-avn-close]')) { closePicker(); return; }
    var anchor = t.closest('a[href]');
    if (anchor) { document.documentElement.style.overflow = ''; return; }
    var b = t.closest('button'); if (!b) return;
    var d = b.dataset;
    if (d.occ) st.occ = d.occ;
    else if (d.gen) st.gen = d.gen;
    else if (d.fmt) st.fmt = d.fmt;
    else if (d.fam) st.fam = st.fam.indexOf(d.fam) > -1 ? st.fam.filter(function (x) { return x !== d.fam; }) : st.fam.concat(d.fam);
    else if (d.note) st.notes = st.notes.indexOf(d.note) > -1 ? st.notes.filter(function (x) { return x !== d.note; }) : st.notes.concat(d.note);
    else if ('avnReset' in d) st = JSON.parse(JSON.stringify(DEFAULTS));
    else if ('avnJump' in d) { resultsEl.scrollIntoView({behavior:'smooth', block:'start'}); return; }
    else return;
    render();
  });
  root.addEventListener('input', function (e) {
    if (e.target.id === 'avn-int') { st.int = +e.target.value; render(); }
    else if (e.target.id === 'avn-warm') { st.warm = +e.target.value; render(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closePicker(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(root.querySelectorAll('a[href],button,input'), function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (location.hash === '#lohnavalija') openPicker(false);
  else if (/\/pages\/lohnavalija\/?$/.test(location.pathname)) openPicker(true);
})();
